import React, { Suspense, useEffect, useState } from 'react';
import { Route, Switch, Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import ErrorPage from '../errors/ErrorPage';
import translate from '@noar-basf/commons';

import {
  // Dashboard,
  Home,
  Profiles,
  UsersListing,
  UserForm,
  CategoriesListing,
  CategoryForm,
  CampaignsListing,
  CampaignForm,
  FragrancesListing,
  FragranceForm,
  QuizListing,
  QuizForm,
  QuizUpdate,
  DevicesListing,
  CapsulesListing,
  NewsListing,
  NewsForm
} from './pages';
import store from '../../store/store';
import { showSpinner, hideSpinner } from '../../store/actions/spinner.actions';

const spinnerActions = {
  showSpinner: () => store.dispatch(showSpinner()),
  hideSpinner: () => store.dispatch(hideSpinner())
};

function AdminPage({ history, translate, user, lang }) {
  const [width, setWidth] = useState(window.innerWidth);

  const subPagesProps = {
    ...spinnerActions,
    history,
    translate,
    user,
    lang,
    width
  };

  const resizeEvent = () => {
    if (window.innerWidth !== width) {
      setWidth(window.innerWidth);
    }
  };

  useEffect(() => {
    window.addEventListener('resize', resizeEvent);
  });

  const { auth } = store.getState();
  if (auth && auth.user && auth.user.profile.nome === 'USER') {
    return <Redirect to="/" />;
  }

  if (auth && auth.user && auth.user.profile.nome === 'POSTNEWS') {
    return (
      <Suspense>
        <Switch>
        <Redirect exact from="/admin" to="/admin/news" />
          <Route exact path="/admin/news">
            <NewsListing {...subPagesProps} />
          </Route>
          <Route exact path="/admin/news/create">
            <NewsForm {...subPagesProps} />
          </Route>
          <Route exact path="/admin/news/:id/update">
            <NewsForm {...subPagesProps} />
          </Route>
        </Switch>
      </Suspense>
    );
  }
  
  return (
    <Suspense>
      <Switch>
        {/* DASHBOARD */}
        {/* <Route path='/admin/dashboard' component={() => <Dashboard width={width} />} /> */}
        <Redirect exact from="/admin" to="/admin/home" />

        {/* HOME */}
        <Route path="/admin/home">
          <Home {...subPagesProps} />
        </Route>

        {/* USUARIOS */}
        <Route exact path="/admin/users">
          <UsersListing width={width} {...subPagesProps} />
        </Route>

        <Route path="/admin/users/create">
          <UserForm {...subPagesProps} />
        </Route>

        <Route path="/admin/users/:id/update">
          <UserForm {...subPagesProps} />
        </Route>

        <Route exact path="/admin/categories">
          <CategoriesListing {...subPagesProps} />
        </Route>

        <Route exact path="/admin/categories/create">
          <CategoryForm {...subPagesProps} />
        </Route>

        <Route exact path="/admin/categories/:id/update">
          <CategoryForm {...subPagesProps} />
        </Route>

        <Route exact path="/admin/campaigns">
          <CampaignsListing {...subPagesProps} />
        </Route>

        <Route exact path="/admin/campaigns/create">
          <CampaignForm {...subPagesProps} />
        </Route>

        <Route exact path="/admin/campaigns/:id/update">
          <CampaignForm {...subPagesProps} />
        </Route>

        <Route exact path="/admin/fragrances">
          <FragrancesListing {...subPagesProps} />
        </Route>

        <Route exact path="/admin/fragrances/create">
          <FragranceForm {...subPagesProps} />
        </Route>

        <Route exact path="/admin/fragrances/:id/update">
          <FragranceForm {...subPagesProps} />
        </Route>

        <Route exact path="/admin/quiz">
          <QuizListing {...subPagesProps} />
        </Route>

        <Route exact path="/admin/quiz/create">
          <QuizForm {...subPagesProps} />
        </Route>

        <Route exact path="/admin/quiz/:id/update">
          <QuizUpdate {...subPagesProps} />
        </Route>

        <Route exact path="/admin/devices">
          <DevicesListing {...subPagesProps} />
        </Route>

        <Route exact path="/admin/capsules">
          <CapsulesListing {...subPagesProps} />
        </Route>

        <Route exact path="/admin/news">
          <NewsListing {...subPagesProps} />
        </Route>
        <Route exact path="/admin/news/create">
          <NewsForm {...subPagesProps} />
        </Route>
        <Route exact path="/admin/news/:id/update">
          <NewsForm {...subPagesProps} />
        </Route>

        {/* PERFIL */}
        {auth && auth.user && auth.user.profile.nome === 'ADMIN' ? (
          <Route path="/admin/perfis">
            <Profiles {...spinnerActions} />
          </Route>
        ) : null}

        {/* ERROR */}
        <Route path="*" component={ErrorPage} />
      </Switch>
    </Suspense>
  );
}

function mapStateToProps(store) {
  return {
    translate: translate(store.i18n.lang),
    lang: store.i18n.lang,
    user: store.auth.user
  };
}

export default connect(mapStateToProps)(AdminPage);
